export const GENERAL_ERROR_CODE = 'GENERAL_ERROR';
export const UNEXPECTED_ERROR_CODE = 'UNEXPECTED_ERROR';
export const NETWORK_ERROR_CODE = 'NETWORK_ERROR';

export const UNEXPECTED_ERROR_MESSAGE =
  'Ocurrió un error inesperado. Por favor, intenta nuevamente.';
export const NETWORK_ERROR_MESSAGE = 'No se pudo conectar con el servidor.';
export const GENERAL_ERROR_MESSAGE =
  'Ocurrió un error al procesar tu solicitud.';

export const TECHNICAL_ERROR_CODES = [
  'NIT9998', // Error de base de datos
  'NIT9999', // Error interno del servidor
];
